import React, { PropsWithChildren, useCallback, useRef, useState } from 'react'

import BlockPreContent from '@components/atoms/BlockPreContent'
import Box from '@components/atoms/Box'
import { BoxBackgrounds } from '@components/atoms/Box/Box'
import Col from '@components/atoms/Grid/Col'
import Row from '@components/atoms/Grid/Row'
import FormContact from '@components/molecules/Forms/FormContact'
import { Root } from '@components/storyblok/molecules/Forms/StoryblokContactForm/StoryblokContactForm.styles'

import { PropsWithClassName } from '@helper/PropsWithClassName'
import { editable } from '@helper/storyblokEditable'

import { ContactForm } from '@definitions/types/storyblokTypes'

interface Props extends PropsWithClassName {
  blok: ContactForm
}

const StoryblokContactForm: React.FC<PropsWithChildren<Props>> = (
  props: PropsWithChildren<Props>
): React.JSX.Element => {
  const { blok } = props
  const { headline, subline } = blok

  const onSubmit = useCallback(async (data: object) => {}, [])

  return (
    <Root
      {...editable(blok)}
      className={props.className}
      data-testid={'storyblok-contact-form-root'}
      aria-label={blok.headline?.toString()}
      title={blok.headline?.toString()}
    >
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <BlockPreContent headline={headline} subline={subline} />
        </Col>
        <Col xs={12} sm={12} md={10} mdOffset={1} lg={8} lgOffset={2}>
          <Box background={BoxBackgrounds.WHITE}>
            <FormContact
              formId="contact"
              handleSubmitForm={() => console.log('handleSubmitForm')}
            />
          </Box>
        </Col>
      </Row>
    </Root>
  )
}

export { StoryblokContactForm }
